// frontend/src/components/common/VideoModal.js
import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import VideoPlayer from "../video/VideoPlayer";
import "./VideoModal.css";

const VideoModal = ({ isOpen, onClose, videoUrl, title = "Video" }) => {
  const [delayedVideoUrl, setDelayedVideoUrl] = React.useState("");

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
      // Small delay to ensure modal is fully rendered before loading video
      const timer = setTimeout(() => {
        setDelayedVideoUrl(videoUrl);
      }, 100);
      return () => {
        clearTimeout(timer);
        document.removeEventListener("keydown", handleEscape);
        document.body.style.overflow = "auto";
        setDelayedVideoUrl("");
      };
    } else {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "auto";
      setDelayedVideoUrl("");
    }
  }, [isOpen, onClose, videoUrl]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="video-modal-overlay" onClick={onClose}>
      <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="video-modal-close" onClick={onClose}>
          ×
        </button>
        <div className="video-modal-player">
          {delayedVideoUrl && (
            <VideoPlayer
              videoUrl={delayedVideoUrl}
              title={title}
              autoplay={true}
              onEnded={onClose}
            />
          )}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default VideoModal;